import React from 'react';

function Footer(props) {
    return (
        <div style={{background:'bisque'}}>
            <h6 style={{'margin-top':'4px'}}> Copyright@Prakash Tiwari</h6>
            <div style={{'marginRight':'auto','marginLeft':'auto',width:'20%'}}>
                <a href='#fb' style={{background:'blue', color:'white',borderRadius:'10px',margin:'2px', 'text-decoration':'none',padding:'4px'}}>facebook</a>
                <a href='#insta' style={{background:'red', color:'white',borderRadius:'10px',margin:'2px','text-decoration':'none',padding:'4px'}}>Instagram</a>
                <a href='#quora' style={{background:'#800000' ,color:'white',borderRadius:'10px',margin:'2px','text-decoration':'none',padding:'4px'}}>Quora</a>
            </div>
        </div>
    );
}

export default Footer;